import { PubSub } from "@aws-amplify/pubsub"

let pubSub: PubSub | undefined

type PubSubErrorLike = {
    errorCode?: number
    errorMessage?: string
    message?: string
    uri?: string
}

class AppPubSub extends PubSub {
    override onDisconnect({
        clientId,
        errorCode,
        ...args
    }: {
        clientId?: string
        errorCode?: number
    }): void {
        const hasActiveObservers =
            !!clientId &&
            !!this._clientIdObservers.get(clientId) &&
            this._clientIdObservers.get(clientId)!.size > 0

        // Amplify v6 logs errorCode 8 for a normal socket close after the
        // last observer unsubscribes and the client intentionally disconnects.
        if (errorCode === 8 && !hasActiveObservers) {
            return
        }

        super.onDisconnect({ clientId, errorCode, ...args })
    }
}

function generatePubSubClientId(): string {
    const randomValue =
        window.crypto?.getRandomValues(new Uint32Array(1))[0] ??
        Math.floor(Math.random() * Number.MAX_SAFE_INTEGER)

    return randomValue.toString(36).slice(0, 6).padStart(6, "0")
}

export function getPubSub(): PubSub {
    if (!pubSub) {
        pubSub = new AppPubSub({
            clientId: `spa-${generatePubSubClientId()}`,
            region: process.env.REACT_APP_IOT_REGION,
            endpoint: process.env.REACT_APP_MQTT_ENDPOINT,
        })
    }
    return pubSub
}

export function logPubSubError(
    error: unknown,
    context: { topicSuffix: string; identityId: string },
): void {
    const value = (error || {}) as PubSubErrorLike
    const message = value.errorMessage || value.message || String(error)
    const isSocketClosed = message.includes("Socket closed")
    const isCredentialSignedUrl =
        typeof value.uri === "string" && value.uri.includes("X-Amz-Credential=")

    console.warn("[PubSub] subscription error", {
        topicSuffix: context.topicSuffix,
        identityId: context.identityId,
        errorCode: value.errorCode,
        errorMessage: message,
        isSocketClosed,
        isCredentialSignedUrl,
        uri: value.uri,
    })
}
